import { addPopupAction, LAYER } from 'js/components/common/PopupManager';
import { QuickDepositPopup } from './QuickDepositPopup';

export const showQuickDepositAction = ({ onClose } = {}) =>
    addPopupAction({
        component: QuickDepositPopup,
        layer: LAYER.QUICK_DEPOSIT,
        onClose
    });
